/**
 * Display helpers for search reports (section titles, field emptiness).
 */

const SECTION_TITLE_RULES: { pattern: RegExp; title: string }[] = [
  { pattern: /upi|finanx.*vpa|vpa/i, title: 'UPI Verification' },
  { pattern: /pan|checkx\/pan/i, title: 'PAN Verification' },
  { pattern: /ifsc|cashfree/i, title: 'IFSC / Bank Branch' },
  { pattern: /imei/i, title: 'IMEI Device Lookup' },
  { pattern: /numverify|phone.*valid/i, title: 'Phone Validation' },
  { pattern: /eyecon/i, title: 'Eyecon Caller ID' },
  { pattern: /hiya/i, title: 'Hiya Phone Data' },
  { pattern: /leakcheck.*phone|phone.*leakcheck/i, title: 'Phone Breach Data' },
  { pattern: /leakcheck.*email|email.*leakcheck/i, title: 'Email Breach Data' },
  { pattern: /google.*data|google.*search/i, title: 'Google OSINT' },
  { pattern: /ip.*geo|geolocation/i, title: 'IP Geolocation' },
  { pattern: /ip.*quality|quality.*score/i, title: 'IP Risk & Quality' },
  { pattern: /vehicle|registration|\brc\b/i, title: 'Vehicle Registration' },
  { pattern: /voter|epic/i, title: 'Voter ID Verification' },
  { pattern: /cin|company/i, title: 'Company Registration' },
  { pattern: /din|director/i, title: 'Director Details' },
  { pattern: /archive\.?org|domain/i, title: 'Domain Archive' },
  { pattern: /account finder/i, title: 'Account Finder' },
];

/** Map raw API / template section headings to user-friendly labels. */
export function getFriendlySectionTitle(heading: string): string {
  if (!heading?.trim()) return 'Results';
  const normalized = heading.trim();
  const lower = normalized.toLowerCase();
  for (const rule of SECTION_TITLE_RULES) {
    if (rule.pattern.test(lower)) return rule.title;
  }
  return normalized
    .replace(/^api\.attestr\.com\s*/i, 'Attestr ')
    .replace(/\s+api\s*$/i, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Whether a template field has no displayable value. */
export function isEmptyFieldValue(value: unknown, missingApi?: boolean): boolean {
  if (missingApi) return true;
  if (value === null || value === undefined) return true;
  if (typeof value === 'string') {
    const t = value.trim();
    return t === '' || t.toLowerCase() === 'n/a';
  }
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') return Object.keys(value as object).length === 0;
  return false;
}

export function countSectionStats(fields: { value?: unknown; missing_api?: boolean }[]): {
  total: number;
  filled: number;
  empty: number;
} {
  const total = fields.length;
  const filled = fields.filter((f) => !isEmptyFieldValue(f.value, f.missing_api)).length;
  return { total, filled, empty: total - filled };
}
